import type { Lang } from '../i18n/index.js';
import { theme } from '../theme.js';

/**
 * Shown whenever the screens are running on invented data.
 *
 * Deliberately impossible to miss. Someone glancing at a demonstration must
 * never take these figures for a client's real accounts, and screenshots get
 * passed around without their context — which is also why it is translated. A
 * warning only the English speakers can read is not a warning.
 */
const COPY: Record<Lang, { strong: string; rest: string }> = {
  en: {
    strong: 'Demonstration data.',
    rest: ' Every company, contact and figure on these screens is invented. Nothing here comes from Xero, and nothing you do here reaches it.',
  },
  ar: {
    strong: 'بيانات تجريبية.',
    rest: ' كل مؤسسة وجهة اتصال ورقم على هذه الشاشات مُختلق. لا شيء هنا مأخوذ من Xero، ولا شيء تفعله هنا يصل إليه.',
  },
};

export function DemoDataBanner({ lang }: { lang: Lang }) {
  const copy = COPY[lang];
  return (
    <div
      role="status"
      style={{
        flex: '0 0 auto',
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        margin: '0 18px 10px',
        padding: '9px 14px',
        background: '#FAF3E4',
        border: '1px solid #EADFC2',
        borderRadius: theme.radiusControl,
        fontSize: '12.5px',
        color: theme.warnDeep,
      }}
    >
      <span
        style={{
          flex: '0 0 auto',
          width: '18px',
          height: '18px',
          borderRadius: theme.radiusPill,
          background: '#EADFC2',
          display: 'grid',
          placeItems: 'center',
          fontWeight: 700,
          fontSize: '11px',
        }}
      >
        !
      </span>
      <span>
        <strong>{copy.strong}</strong>
        {copy.rest}
      </span>
    </div>
  );
}
